<div class="page_bottom_space" id="quote-page-scroll-top">
  <!-- <div id="guestSaveQuoteProcess" class="mb-5">
  <div class="vh_center mt-4">
    <div col="12">
      <div style=" margin:0px; " class="vh_center">
        <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
        <div style="width:130px; height:5px; background-color: #fcb816;"></div>
        <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
        <div style="width:130px; height:5px; background-color: #fcb816;"></div>
        <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
      </div>
    </div>
  </div>
  <div class="vh_center mt-2">
    <div col="12">
      <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
        <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
        <div style="width:150px;  padding-left: 30px; background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Quote</div>
        <div style="width:175px; padding-left: 0px;  background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Request Custom Quote</div>
        <div style="width:150px;  padding-left: 20px; background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Quote</div>
        <div style="width:150px; padding-left: 15px;  background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Save Quote</div>
      </div>
    </div>
  </div>
  <div class="row mt-5 container-fluid mb-5">
    <div class="fs-3 mt-5 text-center"><span *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Processing your request,</span><span *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Saving your quote,</span> please wait…</div>
    <div class="progress m-3" style="--bs-progress-bar-bg: #fcb814 !important;">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-label="Example with label" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>
</div> -->
<div class="container-fluid border-0" id="finalQuoteDetails">
  <div class="vh_center mt-4">
    <div col="12">
      <div style=" margin:0px; " class="vh_center">
        <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
        <div style="width:130px; height:5px; background-color: #fcb816;"></div>
        <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
        <div style="width:130px; height:5px; background-color: #dadada;"></div>
        <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
        <div style="width:130px; height:5px; background-color: #dadada;"></div>
        <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
        <div style="width:130px; height:5px; background-color: #dadada;"></div>
        <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      </div>
    </div>
  </div>
  <div class="vh_center mt-2">
    <div col="12">
      <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
        <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
        <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
        <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
        <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
        <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
      </div>
    </div>
  </div>
  @if (this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2') {
    <h3 class="text-center header-title page_top_space" > <b>Confirm Quote Request</b> </h3>
  }
  <!-- <div class="text-center fw-b fs-4 p-2"></div> -->
  @if (commonService.commonMainObj.finalBomDataToPurchase?.issueFound != null && !commonService.commonMainObj.reQuoteCheck && !commonService.commonMainObj.greaterQtyResp) {
    <div class="col-12 text-center">
      <div class="col-8 offset-2 mt-3 mb-3" id="error-msg-sec1" style="color: red;font-size: 18px;">
        <div class="un_resolve_blink_me">
          <b>Note: All BOM issues are not resolved. </b>
        </div>
        <div>
          Components quote displayed in 'Final Quote' table is a budgetary price and only covers the components that do not have issues.
        </div>
        <div>
          Click on <a (click)="openBomUnResolveList(unResolveLineItems)" class="text-info text_deco_underline cursor-pointer">Component List</a> to view the components with unresolved BOM issues.
        </div>
      </div>
    </div>
  }
  @if (this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2') {
    <div class="text-center" >
      <p class="m-0">Thank you for requesting <span>a @if (commonService.commonMainObj.onlyPcb) {
        <b> PCB </b>
        } @if (!commonService.commonMainObj.onlyPcb) {
        <b> PCB+Assembly </b>
        }</span> quote. Your request# is <span class="yellow-txt fw-bolder">{{commonService.commonMainObj.wqId}}</span></p>
        <!-- <p class="m-0">We need further assessment for this quote.</p>
        <p class="">Someone from our sales team will contact you shortly.</p>
        <p class="">Our business hours are Monday thru Friday, 8:00 AM to 5:30 PM.</p> -->
      </div>
    }
    <!-- <div class="col-12 text-center mt-4">
    <div class="col-8 offset-2 mt-3 mb-3" id="error-msg-sec" *ngIf="commonService.commonMainObj.uploadedFilesData?.fileWarnings && commonService.commonMainObj.pcbType == 'Standard PCB'">
      <div class="red-txt">Issues found in uploaded files are not yet fixed, hence we can only generate a budgetary quote. To get a final quote, please upload new files</div>
    </div>
  </div> -->
  @if (this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2') {
    <div class="col-12 text-center mt-4" >
      <div class="col-10 offset-1 bg_yellow">
        <div class="row p-1">
          <b>Quote for <span>{{commonService.commonMainObj.wqId}}</span> </b>
        </div>
      </div>
    </div>
  }
  @if (commonService.commonMainObj.pcbType == 'Custom/Advanced PCB') {
    <div class="col-12 text-center mt-4" >
      <div class="col-10 offset-1 bg_yellow">
        <div class="row p-1 btn  cursor-default">
          <b>Quote Details</b>
        </div>
      </div>
      <!-- OFP-3120 -->
      @if(commonService.commonMainObj.customAssemblySelected == true){
        <div class="text-center txt-align mt-3">
          <div class="text-center bdr-sec">
          <div class="p-1"> <img class=" " src="assets/img/Extracted_icon.png" width="25" height="25" /> Extracted From Uploaded Data File</div>
          <div class="p-1"> <img class=" " src="assets/img/Default_icon.png" width="25" height="25" /> Default Value</div>
          <div class="p-1"> <img class=" " src="assets/img/Updated_icon.png" width="25" height="25" /> User Updated Value</div>
          </div>
        </div>
      }
    </div>
  }
  <div class="col-12">
    <div class="mb-3">
      <div class="col-10 mt-3 offset-1 grey-border" style="padding: 15px;border-radius: 5px;">
        <div class="row p-1">
          @if (this.commonService.commonMainObj.userData.firstName) {
            <div class="col-6">
              <div class="col-10"><b>Name:</b> {{this.commonService.commonMainObj.userData.firstName}} {{this.commonService.commonMainObj.userData.lastName}} </div>
              <div class="col-2"></div>
            </div>
          }
          @if (this.commonService.commonMainObj.userData.registrationCompany) {
            <div class="col-6">
              <div class="col-10"><b>Company: </b>{{this.commonService.commonMainObj.userData.registrationCompany}}</div>
              <div class="col-2"></div>
            </div>
          }
        </div>
        <div class="row p-1">
          @if (this.commonService.commonMainObj.email) {
            <div class="col-6">
              <div class="col-10"><b>Email :</b> {{this.commonService.commonMainObj.email}}</div>
              <div class="col-2"></div>
            </div>
          }
          @if (this.commonService.commonMainObj.userData.phone) {
            <div class="col-6">
              <div class="col-10"><b>Phone :</b> {{this.commonService.commonMainObj.userData.phone}}</div>
              <div class="col-2"></div>
            </div>
          }
        </div>
        <div class="row p-1">
          @if (this.commonService.commonMainObj.uploadedFilesData.filename) {
            <div class="col-6">
              <div class="col-10 design_file_bom_file_name"><b>Design File : </b> <span title="{{this.commonService.commonMainObj.uploadedFilesData.filename}}">{{this.commonService.commonMainObj.uploadedFilesData.filename}}</span></div>
              <div class="col-2"></div>
            </div>
          }
          @if (this.commonService.commonMainObj.uploadedBomFileName) {
            <div class="col-6">
              <div class="col-10 design_file_bom_file_name"><b>BOM File : </b> <span title="{{commonService.commonMainObj.uploadedBomFileName}}">{{this.commonService.commonMainObj.uploadedBomFileName}}</span></div>
              <div class="col-2"></div>
            </div>
          }
        </div>
        <div class="row p-1">
          <div class="col-6">
            <!--  (click)="orderPlaceGuest()" -->
            <div class="col-10"><b>Part Number :</b> {{savedPartNum}}</div>
            <div class="col-2"></div>
          </div>
          <div class="col-6">
            <div class="col-10"><b>Revision :</b> {{savedPartRevision}}</div>
            <div class="col-2"></div>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-6">
            <div class="col-10"><b>Surface Finish :</b> {{commonService.commonMainObj.surfaceFinish}}</div>
            <div class="col-2"></div>
          </div>
          <div class="col-6">
            <div class="col-10"><b>Material :</b> {{commonService.commonMainObj.material}}</div>
            <div class="col-2"></div>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-6">
            <div class="col-10"><b>Board Dimensions : </b>{{commonService.commonMainObj.savedBoardDimensions}}</div>
            <div class="col-2"></div>
          </div>
          <div class="col-6">
            <div class="col-10"><b>Layers :</b> {{savedLayer}}</div>
            <div class="col-2"></div>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-6">
            <div class="col-10"><b>ITAR applicable : </b>{{savedItar}}</div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>
      <!-- <div class="col-10 offset-1" style="display: flex;">
      <div class="col-6 box_sec_pcb">
        <div class="half-sec text-center">
          <div class="mt-5">Thank you for requesting an <b>Advanced PCB quote</b>.</div>
          <div>Your request# is <span class="yellow-txt fw-bolder">TQX-201.</span></div>
          <div>We need further assessment for this quote.</div>
          <div>Someone from our sales team will contact shortly.</div>
          <div class="mt-3"><i>Our bussiness hours are <br/> Monday thru Friday, 8:00 AM to 5:30 PM</i></div>

        </div>
      </div>
      <div class="col-6 box_sec_assembly">
        <div class="half-sec">
          <p><strong>Assembly & Components</strong></p>
          <div class="m-2" style="border:1px solid #ccc;padding: 10px;">
            <div class="row">
              <div class="mb-3 col-7">
                <div class="fs14">Number of assemblies:<br/> <span class="fs12">(Assembly + Components)</span></div>
              </div>
              <div class="mb-3 col-5 text-center">
                <select class="select_view fs14">
                  <option value="10boards">10 Boards</option>
                  <option value="25boards">25 Boards</option>
                  <option value="50boards">50 Boards</option>
                  <option value="100boards">100 Boards</option>
                </select>
              </div>
              <div class="mb-3 col-7">
                <div class="fs14">Turn-time:</div>
              </div>
              <div class="mb-3 col-5 text-center">
                <select class="select_view fs14">
                  <option value="10boards">10 Boards</option>
                  <option value="25boards">25 Boards</option>
                  <option value="50boards">50 Boards</option>
                  <option value="100boards">100 Boards</option>
                </select>
              </div>
              <div class="mb-3 col-7">
                <div class="fs14">Number of sides to be assembled:</div>
              </div>
              <div class="mb-3 col-5 p-0">
                <div class="mt-3 fs14 text-center">
                  <span class="pe-2"><input type="radio" name="oneside"/> <span> One </span> </span>
                  <span><input type="radio" name="twoside"/> <span> Two </span> </span>
                </div>
              </div>
              <div class="mb-3 col-7">
                <div class="fs14">Electrical testing:</div>
              </div>
              <div class="mb-3 col-5 text-center">
                <label class="switch">
                  <input type="checkbox" checked>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> -->
  </div>
  <div class="mt-4 mb-3" id="standard-pcb-quote-sec">
    <div class=" col-10 offset-1 grey-border" style="padding: 6px 0;border-radius: 5px">
      <!-- <div class="p-3 fw-bolder">Order Description</div>
      <div class="col-5 offset-md-4 p-2">
        <div class="text-left">
          <label class="pe-5 col-6 fs14">Number of PCB(s): </label>
          <select class="select_view col-6">
            <option value="xccvbxcb">xccvbxcb</option>
            <option value="segfdf">segfdf</option>
            <option value="fdgsdfg">fdgsdfg</option>
            <option value="dsfgdf">dsfgdf</option>
            <option value="xccsdfgsdfvbxcb">xccsdfgsdfvbxcb</option>
          </select>
        </div>
      </div>
      <div class="col-5 offset-md-4 p-2">
        <div class="text-left">
          <label class="pe-5 col-6 fs14">Turn-time: </label>
          <select class="select_view col-6">
            <option value="3 days">3 days</option>
            <option value="7 days">7 days</option>
            <option value="9 days">9 days</option>
          </select>
        </div>
      </div>
      <div class="text-center mt-4 mb-3">
        <button type="button" class="btn btn-warning px-xxl-5 fs14" data-mdb-toggle="button" autocomplete="off" aria-pressed="true"> <i class="fa fa-refresh" aria-hidden="true"></i> <b> Re-calculate</b></button>
      </div> -->
      <div class="col-12 px-3 mt-3 fw-bolder">Final Quote:</div>
      <div class="col-12 p-3 justify-content-center" id="budgetaryQuoteTableSec">
        <div class="col-sm-12">
          <div class="table-responsive" id="budgetaryQuoteTable">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
              <thead>
                <tr>
                  <th align="center" valign="middle">LINE ITEM</th>
                  <th align="center" valign="middle">PART# / REV</th>
                  <th align="center" valign="middle">QUANTITY</th>
                  <th align="center" valign="middle">TURN TIME</th>
                  <th align="center" valign="middle">UNIT PRICE</th>
                  <th align="center" valign="middle">LOT PRICE</th>
                  <th align="center" valign="middle">NRE</th>
                  <th align="center" valign="middle">ELECTRICAL TESTING</th>
                  <th align="center" valign="middle">MISC / OTHER</th>
                  <th align="center" valign="middle">SUBTOTAL</th>
                </tr>
              </thead>
              <tbody id="quote-display-tbody"></tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- <div class="col-12  px-3 fw-bolder">Note:</div>
      <div class="col-12  px-3">
        <ul class="list-type-number">
          <li>As this is your first order, we are providing <b> Free Flying Probe Test.</b></li>
          <li>In addition, we are providing <b> 10% discount </b> on overall cost and <b> free Shipping.</b> </li>
        </ul>
      </div> -->
      <section class="container mb-4" style="display: none;">
        <div style="display: flex;">
          <div class="plr-15" style="padding-top: 5px; padding-left: 0;">Electrical Testing: </div>
          <div class="btn-group2" id="">
            <input (click)="switchOfButtons($event, '')" type="button" class="btn btn-switch " id="electricalTestingYes" value="Yes"/>
            <input (click)="switchOfButtons($event, '')"  type="button" class="btn btn-switch" id="electricalTestingNo" value="No" />
          </div>
        </div>
      </section>
      <section class="container" style="display: none;">
        <div class="row">
          <div class="col-12 p-3 justify-content-center text-center">
            <p>If you are placing the order within the next <b>one hour</b>, we will gaurantee delivery by <b>30/09/2023</b> </p>
          </div>
        </div>
      </section>
    </div>
  </div>
  @if (commonService.commonMainObj.pcbType == 'Custom/Advanced PCB') {
    <div class="mt-4 mb-3" >
      <!-- <div class="mt-4 mb-3" > -->
      <h3 class="text-center header-title"> <b>Confirm Quote Request</b> </h3>
      <div class=" col-10 offset-1 mt-4 grey-border" style="padding: 6px 0;border-radius: 5px">
        <div class="text-center" style="padding: 20px;">
          @if (!commonService.commonMainObj.greaterQtyResp) {
            <p>This is an <b>Advanced PCB</b>(custom quote)  request and is ineligible for an instant online quote @if (!commonService.commonMainObj.reQuoteCheck) {
            <span>due to following advanced specifications:</span>
          }</p>
        }
        @if (commonService.commonMainObj.greaterQtyResp) {
          <p> Based on quantity and complexity of your Assembly, We are unable to provide an instant online price for assembly labor. You will be redirected to Advanced PCB flow where your request will be reviewed offline. </p>
        }
        @if (!commonService.commonMainObj.reQuoteCheck) {
          <p class="ofp-link" (click)="openListOfSpecification(listOfSpecification)">List of advanced specifications</p>
        }
        <p>We need to further assess the files and specification offline to generate a quote.</p><br>
        <p>To proceed with this request as a custom quote, provide <b>@if (!commonService.commonMainObj.greaterQtyResp) {
          <span>Quantity and </span>
          }Turntime for @if (commonService.commonMainObj.bomFileIncluded && !commonService.commonMainObj.greaterQtyResp) {
          <span>PCB</span>
          }@if (!commonService.commonMainObj.bomFileIncluded && !commonService.commonMainObj.greaterQtyResp) {
          <span>PCB and Assembly </span>
        } </b> <b> @if (commonService.commonMainObj.greaterQtyResp) {
        <span>Assembly</span>
      }</b> and click on @if (commonService.commonMainObj.customAssemblySelected != true) {
      <b>'Request for Custom Quote'</b>
      }@if (commonService.commonMainObj.customAssemblySelected == true) {
      <b> 'Proceed' <!--'Request for Custom Quote'--></b>
    } button </p>
    <p>Someone from our sales team will contact you shortly.</p>
    @if (!commonService.commonMainObj.reQuoteCheck && !commonService.commonMainObj.greaterQtyResp) {
      <p>Else, <b>Upload New Files</b> that meet Standard PCB Specifications
      <!-- <a class="ofp-link" target="_blank"  href="{{apiService.Pcb_Specification_URL}}">Standard PCB Specifications</a>  -->
    or click on 'Back' button to change PCB specifications.</p>
    }<br>
    <div><p><i>Note: Our business hours are Monday thru Friday, 8.00 AM to 5.30 PM. </i></p></div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 mb-3">
      <div class="row justify-content-center">
        <div class="col-4  brd-label" style="text-align-last: end;">
          <label style="margin-right:5px;"><b>Number of Boards:</b></label>
        </div>
        <div class="col-4 ">
          <input class="form-control " name="numOfBoards" id="numOfBoards"  [(ngModel)]="quoteDetailList.numOfBoards" (keyup)="changeAssemblyTurnTime(quoteDetailList.numOfBoards,$event)">
        </div>
        <div class="col-4">&nbsp;</div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="row justify-content-center">
        <div class="col-4 brd-label" style="text-align-last: end;">
          <label style="margin-right: 5px;"><b>PCB Turn-time:</b></label>
        </div>
        <div class="col-4 ">
          <select class="form-select" id="pcb-turn-time" [(ngModel)]="quoteDetailList.pcbTurnTime">
            <!-- <option value="1">1 day</option> -->
            <option value="2">2 days</option>
            <option value="3">3 days</option>
            <option value="4">4 days</option>
            <option value="5">5 days</option>
            <option value="7">7 days</option>
            <option value="10">2 Weeks</option>
            <option value="15">3 Weeks</option>
            <option value="20">4 Weeks</option>
          </select>
        </div>
        <div class="col-4">&nbsp;</div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="row justify-content-center">
        <div class="col-4 brd-label" style="text-align-last: end; font-size: 20px;">
          <label style="margin-right: 5px;"><b style="color: #09116c;">Add Assembly?</b></label>
        </div>
        <div class="col-4" style="margin-top: 5px;">
          <input type="button" class="btn btn-switch btn-gray" style="width: 80px;font-size: 14px;" id="assemblyYes" value="Yes" (click)="switchOfButtons($event, assemblyErrorModal)"/>
          <input type="button" class="btn btn-switch btn-green active"  style="width: 80px;font-size: 14px;" id="assemblyNo" value="No" (click)="switchOfButtons($event, '')"/>
        </div>
        <div class="col-4">&nbsp;</div>
      </div>
    </div>
  </div>
  @if (commonService.commonMainObj.customAssemblySelected == true) {
    <div class="row justify-content-center" >
      <div class="col-12 mb-3">
        <div class="row justify-content-center">
          <div class="col-4  brd-label" style="text-align-last: end;">
            <label style="margin-right:5px;"><b>BOM File  :</b><br/><i style="font-size: 13px;">(Retrieved from uploaded file)</i></label>
          </div>
          <div [ngClass]="commonService.commonMainObj.autoUploadFileName || commonService.commonMainObj.uploadedFile?.name ? 'col-8' : 'col-4' " >
            @if (commonService.commonMainObj.autoUploadFileName || commonService.commonMainObj.uploadedFile?.name) {
              <div>
                <div style="position: relative;">
                  <!-- <input type="file" class="form-control customize-input file-input uploadBomInput" value="null" id="assembly_bom_file_upload" name="fileupload" (change)="fileBrowseHandler($event)" style="width: 68%;height: 40px;"/>
                  <label for="assembly_bom_file_upload" style="position: absolute;top: 7px;">
                    <button class="btn btn-warning fs14 me-2">Upload another BOM</button>
                  </label> -->
                  <div class="row">
                    <div class="col-5">
                      @if (!commonService.commonMainObj.autoUploadFileName) {
                        <div class="mt-2" style="word-wrap: break-word;">{{commonService.commonMainObj.uploadedFile?.name}} </div>
                      }
                      @if (commonService.commonMainObj.autoUploadFileName) {
                        <div class="mt-2" style="word-wrap: break-word;">{{commonService.commonMainObj.autoUploadFileName}} </div>
                      }
                    </div>
                    <div class="col-7 p-0" style="display: inline-flex;">
                      <div><span class="not-bom-text" style="font-size: 13px;"><i>Not the BOM you wanted?</i></span></div>
                      <div><button class="btn btn-warning fs14 me-2"  (click)="uploadFiles($event)" title="{{commonService.commonMainObj.autoUploadFileName || commonService.commonMainObj.uploadedFile?.name}}">Upload a Different BOM</button><br>
                      <span style="color: green; font-style: italic; font-size: 13px; font-weight: bold;">(Accepted formats: .xls, .xlsx)</span>
                      <div class="ion-text-left fs15 mt5 pl5">
                        <a href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" style="position:relative;left:-20px;">Download custom BOM format</a>
                      </div>
                    </div>
                  </div>
                </div>
                <input type="file" id="fileInputOther" name="fileInputOther" style="display: none" accept=".xls,.xlsx"
                  (change)="fileBrowseHandler($event)"
                  />
                </div>
              </div>
            }
            <!-- <div class="mt-2" *ngIf="!commonService.commonMainObj.fileUploadedData.uploadedBOM">
            <input type="file" class="form-control customize-input file-input" value="null" id="assembly_bom_file_upload1" name="fileupload" (change)="fileBrowseHandler($event)"/>
          </div> -->
          @if (!commonService.commonMainObj.autoUploadFileName && !commonService.commonMainObj.uploadedFile?.name) {
            <div class="mt-2 mb-1 file-input-container form-control customize-input file-input" >
              <div class="styled-input" style="display: flex;cursor:pointer;" (click)="fileInput.click()">
                <div class="choose-file" >Choose file</div>
                <div class="upload-name" title="{{  curentFileUploadedName }}">{{  curentFileUploadedName || 'No file chosen' }}
                </div>
              </div>
              <input
                type="file"
                #fileInput
                style="display: none" accept=".xls,.xlsx"
                (change)="fileBrowseHandler($event)"
                />
              </div>
            }
            @if (!commonService.commonMainObj.autoUploadFileName && !commonService.commonMainObj.uploadedFile?.name) {
              <span style="color: green; font-style: italic; font-size: 13px; font-weight: bold;">(Accepted formats: .xls, .xlsx)</span>
            }
            <div class="ps-4">
              @if (!commonService.commonMainObj.autoUploadFileName && !commonService.commonMainObj.uploadedFile?.name) {
                <a href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" style="position:relative;left:-20px;">Download custom BOM format</a>
              }
            </div>
          </div>
          @if (!commonService.commonMainObj.autoUploadFileName && !commonService.commonMainObj.uploadedFile?.name) {
            <div class="col-4">&nbsp;</div>
          }
        </div>
      </div>
      <div class="col-12 mb-3">
        <div class="row justify-content-center">
          <div class="col-4  brd-label" style="text-align-last: end;">
            <label style="margin-right:5px;"><b>Number of Assemblies:</b></label>
          </div>
          <div class="col-4 ">
            <!-- <select class="form-select" id="assembly-turn-time" [(ngModel)]="quoteDetailList.customNumOfAssemblies">
            <option value="{{brdQty}}" *ngFor="let brdQty of qtyIndvBoardsArray; let k = index">{{brdQty}}</option>
          </select> -->
          <input class="form-control " name="numOfAssembs" id="numOfAssembs" type="number" [(ngModel)]="quoteDetailList.customNumOfAssemblies" />
        </div>
        <div class="col-4">&nbsp;</div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="row justify-content-center">
        <div class="col-4 brd-label" style="text-align-last: end;">
          <label style="margin-right: 5px;"><b>Assembly Turn-time:</b></label>
        </div>
        <div class="col-4 ">
          <select class="form-select" id="assembly-turn-time" [(ngModel)]="quoteDetailList.customaAssemblyTurnTime">
            <!-- <option value="1">1 day</option> -->
            <option value="2">2 days</option>
            <option value="3">3 days</option>
            <option value="4">4 Days</option>
            <option value="5">5 days</option>
            <option value="7">7 days</option>
            <option value="10">2 Weeks</option>
            <option value="15">3 Weeks</option>
            <option value="20">4 Weeks</option>
          </select>
        </div>
        <div class="col-4">&nbsp;</div>
      </div>
    </div>
    <!-- OFP-405  code -->
    <div class="col-12 mb-3">
      <div class="row justify-content-center">
        <div class="col-4 brd-label" style="text-align-last: end;">
          <label style="margin-right: 5px;"><b>Number of sides to be assembled</b></label>
        </div>
        <div class="col-8 ">
          <input (click)="switchOfAssmButtons($event)" type="button" class="btn btn-switch  " [ngClass]="(commonService.commonMainObj.assemblySides == '1 side' && commonService.commonMainObj.greaterQtyResp) || commonService.commonMainObj.assemblySides == '' ? 'btn-green active' : 'btn-gray' " id="numberOfSidesOne" value="One side"/>
          <input (click)="switchOfAssmButtons($event)" type="button" class="btn btn-switch " [ngClass]="commonService.commonMainObj.assemblySides == '2 sides' && commonService.commonMainObj.greaterQtyResp ? 'btn-green active' : 'btn-gray' " id="numberOfSidesTwo" value="Two sides"/>
          <div  class="ofp-tooltip">
            <img class=" " src="assets/img/{{numOfSidesImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(numOfSidesImg)" (mouseout)="hideImageToolTip(numOfSidesImg)" style="margin-left: 10px;"/> 
            <span class="labelimagetooltip tooltiptext lableImageLabel-{{numOfSidesImg}}"></span>
          </div>
        </div>
        <!-- <div class="col-4">&nbsp;</div> -->
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="row justify-content-center">
        <div class="col-4 brd-label" style="text-align-last: end;">
          <label style="margin-right: 5px;"><b>Lead-free processing</b></label>
        </div>
        <div class="col-8 ">
          <input (click)="switchOfAssmButtons($event)" type="button" class="btn btn-switch " [ngClass]="(commonService.commonMainObj.leadFreeProcessing == 'Yes' && commonService.commonMainObj.greaterQtyResp) ? 'btn-green active' : 'btn-gray' " id="leadFreeYes" value="Yes" />
          <input (click)="switchOfAssmButtons($event)" type="button" class="btn btn-switch " [ngClass]="(commonService.commonMainObj.leadFreeProcessing == 'No' && commonService.commonMainObj.greaterQtyResp) || commonService.commonMainObj.leadFreeProcessing == '' ? 'btn-green active' : 'btn-gray' " id="leadFreeNo" value="No"/> 
          <div  class="ofp-tooltip">
            <img class=" " src="assets/img/{{leadFreeImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(leadFreeImg)" (mouseout)="hideImageToolTip(leadFreeImg)" style="margin-left: 10px;"/> 
            <span class="labelimagetooltip tooltiptext lableImageLabel-{{leadFreeImg}}"></span>
          </div>
        </div>
        <!-- <div class="col-4">&nbsp;</div> -->
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="row justify-content-center">
        <div class="col-4 brd-label" style="text-align-last: end;">
          <b>PCB has <a style="color:#0787bc;cursor: pointer;text-decoration: underline;" href="{{apiService.Via_In_Pad_URL}}" target="_blank">Via-in-pad</a> features?</b>
        </div>
        <div class="col-8 ">
          <!-- <input type="button" class="btn btn-switch " [ngClass]="(commonService.commonMainObj.viaInPadData == 'Yes' && commonService.commonMainObj.greaterQtyResp) ? 'btn-green active' : 'btn-gray' " id="viaInPadsYes" value="Yes" (click)="switchOfViaInPadButtons($event)"/>
          <input type="button" class="btn btn-switch " [ngClass]="(commonService.commonMainObj.viaInPadData == 'No' && commonService.commonMainObj.greaterQtyResp) || commonService.commonMainObj.viaInPadData == '' ? 'btn-green active' : 'btn-gray' " id="viaInPadsNo" value="No" (click)="switchOfViaInPadButtons($event)"/> -->
          <input type="button" class="btn btn-switch " id="viaInPadsYes" value="Yes" (click)="switchOfViaInPadButtons($event)"/>
          <input type="button" class="btn btn-switch " id="viaInPadsNo" value="No" (click)="switchOfViaInPadButtons($event)"/>
          <div  class="ofp-tooltip">
            <img class=" " src="assets/img/{{commonService.commonMainObj.viaInPadCommonImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(commonService.commonMainObj.viaInPadCommonImg)" (mouseout)="hideImageToolTip(commonService.commonMainObj.viaInPadCommonImg)" style="margin-left: 10px;"/> 
            <span class="labelimagetooltip tooltiptext lableImageLabel-{{commonService.commonMainObj.viaInPadCommonImg}}"></span>
          </div>
        </div>
        <!-- <div class="col-4">&nbsp;</div> -->
      </div>
    </div>
  </div>
}
</div>
</div>
}
</div>
@if (commonService.commonMainObj.pcbType != 'Custom/Advanced PCB') {
  <div>
    <div class="offset-1 mt-4">Do you want to Re-quote with a different Quantity or Turntime? 
      <span class="cursor-pointer text-decoration-underline" style="color: #0015ff;" (click)="needReQuote()">Click Here</span>
    </div>
    @if(commonService.commonMainObj.reQuoteShowHide){
        <div class="mt-2 mb-3">
          <div class=" col-6 offset-1 grey-border" style="padding: 6px 0;border-radius: 5px">
            <div class="col-12 p-3 justify-content-center">
              <div class="col-sm-12">
                <div class="table-responsive">
                  <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                    <thead>
                      <tr>
                        <th align="center" valign="middle">Line Item</th>
                        <th align="center" valign="middle">Quantity</th>
                        <th align="center" valign="middle">Turn Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><b>PCB Fabrication</b></td>
                        <td><input type="text" class="form-control" [(ngModel)]=" newPcbQty" (keyup)="newPCBQtyChnge()"/></td>
                        <td>
                          <select class="form-select" [(ngModel)]="newPcbOrgTurnTime">
                            <option value="1 Day">1 Day</option>
                            <option value="2 Days">2 Days</option>
                            <option value="3 Days">3 Days</option>
                            <option value="4 Days">4 Days</option>
                            <option value="5 Days">5 Days</option>
                            <option value="2 Weeks">2 Weeks</option>
                            <option value="3 Weeks">3 Weeks</option>
                            <option value="4 Weeks">4 Weeks</option>
                          </select>
                          <!-- <select class="form-select" [(ngModel)]="newPcbOrgTurnTime">
                          <option value="{{pcbTData.field}}" *ngFor="let pcbTData of commonService.commonMainObj.priceMatrixColData; let idx = index">{{pcbTData.title}}</option>
                        </select> -->
                      </td>
                    </tr>
                    @if (commonService.commonMainObj.onlyPcb == false) {
                      <tr>
                        <td><b>Assembly Labor</b></td>
                        <td><input type="text" disabled class="form-control" [(ngModel)]="newAssemblyQty" readOnly="true"/></td>
                        <td>
                          <select class="form-select" [(ngModel)]="newAssemblyTurnTime">
                            <option value="1 Day">1 Day</option>
                            <option value="2 Days">2 Days</option>
                            <option value="3 Days">3 Days</option>
                            <option value="4 Days">4 Days</option>
                            <option value="5 Days">5 Days</option>
                            <option value="7 Days">7 Days</option>
                          </select>
                          <!-- <select class="form-select" [(ngModel)]="newAssemblyTurnTime">
                          <option value="{{assemblyTData.field}}" *ngFor="let assemblyTData of commonService.commonMainObj.assemblyMatrixColData; let idx = index">{{assemblyTData.title}}</option>
                        </select> -->
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <button type="button" class="btn btn-custom btn-warning px-xxl-5" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="reQuoteGuestCheck(existingQuote)"> <b>Re-Quote </b>
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
<div class="col-12 text-center mb-4 mt-5">
  @if (commonService.commonMainObj.pcbType == 'Custom/Advanced PCB' && !commonService.commonMainObj.reQuoteCheck && !commonService.commonMainObj.greaterQtyResp) {
    <button  type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="backToBoardDetails()"><b>Back</b></button>
  }
  @if (commonService.commonMainObj.finalBomDataToPurchase?.issueFound != null && !commonService.commonMainObj.greaterQtyResp && !commonService.commonMainObj.reQuoteCheck) {
    <button  type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="backToComponentProcurement()"><b>Back</b></button>
  }
  <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-red-custom btn-danger" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Cancel</b>
</button>
@if (!commonService.commonMainObj.reQuoteCheck  && !commonService.commonMainObj.greaterQtyResp) {
  <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="uploadNewFiles()" > <b title="Upload a new design file to start the flow from scratch">Upload New File</b>
</button>
}
<!-- OFP-251 (click)="goToSaveQuote()"  -->
<!-- for OFP-405 remove below cide -->
<!-- <button type="button" *ngIf="commonService.commonMainObj.isGuestUser == false" class="btn btn-custom btn_blue_custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="guestQuoteSave('saveQuote')"> <b *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Request for Custom Quote</b> <b *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Save Quote</b> </button> -->
<!-- OFP-405 add below 2 line code -->
@if (commonService.commonMainObj.isGuestUser == false && commonService.commonMainObj.customAssemblySelected != true) {
  <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="guestQuoteSave('saveQuote')"> @if (commonService.commonMainObj.pcbType == 'Custom/Advanced PCB' && commonService.commonMainObj.customAssemblySelected != true) {
    <b>Request for Custom Quote</b>
    } @if (commonService.commonMainObj.pcbType != 'Custom/Advanced PCB') {
    <b title="Save your quote now to place the order later at your convenience">Save Quote</b>
  }
</button>
}
@if (commonService.commonMainObj.customAssemblySelected == true) {
  <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="bomProceed(autoMapping)"> @if (commonService.commonMainObj.pcbType == 'Custom/Advanced PCB') {
    <b>Proceed</b>
  }
</button>
}
<!--  OFP-405 end -->
<!-- for guest user -->
<!-- OFP-251 (click)="logInToSaveQuote(LoginModal, 'saveQuote')"  -->
<!-- for OFP-405 remove below code -->
<!-- <button type="button" *ngIf="commonService.commonMainObj.isGuestUser == true" class="btn btn-custom btn_blue_custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="guestQuoteSave('saveQuote')"> <b *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Request for Custom Quote</b> <b *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Save Quote</b> </button> -->
<!-- OFP-405 add below  line code -->
@if (commonService.commonMainObj.isGuestUser == true && commonService.commonMainObj.customAssemblySelected != true) {
  <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="guestQuoteSave('saveQuote')"> @if (commonService.commonMainObj.pcbType == 'Custom/Advanced PCB' && commonService.commonMainObj.customAssemblySelected != true) {
    <b>Request for Custom Quote</b>
    } @if (commonService.commonMainObj.pcbType != 'Custom/Advanced PCB') {
    <b title="Save your quote now to place the order later at your convenience">Save Quote</b>
  }
</button>
}
<!--  OFP-405 end -->
@if (commonService.commonMainObj.isGuestUser == false && commonService.commonMainObj.pcbType != 'Custom/Advanced PCB') {
  <button type="button" class="btn btn-custom btn-warning btn_forest_green_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click) = "placeOrder()"> <b>Place Order </b>
</button>
}
<!-- for guest user -->
@if (commonService.commonMainObj.isGuestUser == true && commonService.commonMainObj.pcbType != 'Custom/Advanced PCB') {
  <button type="button" class="btn btn-custom btn-warning btn_forest_green_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="guestOrderPlace('placeOrder')">
    <!-- OFP251 -----placeOrderWithLogin(LoginModal, 'placeOrder') -->
    <b>Place Order </b>
  </button>
}
<!-- <button type="button" class="btn btn-warning fs14 me-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true"> <b>Place order without assembly</b>
</button> -->
</div>
</div>
<!-- <div class="container-fluid border-0" *ngIf="commonService.commonMainObj.rNumber">
<div class="vh_center mt-4">
  <div col="12">
    <div style=" margin:0px; " class="vh_center">
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
    </div>
  </div>
</div>
<div class="vh_center mt-2">
  <div col="12">
    <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
      <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
      <div style="width:150px;  padding-left: 30px; background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Quote</div>
      <div style="width:175px; padding-left: 0px;  background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Request Custom Quote</div>
      <div style="width:150px;  padding-left: 20px; background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Quote</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Save Quote</div>
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-8 text-center succ-div">
    <h2 style="color:#db9e0a;font-weight:600;">Your request for custom quote is accepted!</h2>
    <h5>Someone from our sales team will contact you shortly.</h5>
    <h5 class="mt-3 fw-b">Your Request Number is <span style="color:#db9e0a;font-weight:600 ;">{{commonService.commonMainObj.rNumber}}</span></h5>
  </div>
</div>
<div class="text-center">
  <button type="button" class="btn btn-custom mb-4 mt-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" *ngIf="commonService.commonMainObj.rNumber" (click)="commonService.goBack()"> <b>Back to Home</b>
</button>
</div>
</div> -->

<!-- OFP-338 -->
<!-- <div class="container-fluid border-0" id="saveQuoteSuccessData" >
<div class="vh_center mt-4" *ngIf="commonService.commonMainObj.saveQuoteAccessUrl || commonService.commonMainObj.saveQuoteMessage">
  <div col="12">
    <div style=" margin:0px; " class="vh_center">
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
    </div>
  </div>
</div>
<div class="vh_center mt-2" *ngIf="commonService.commonMainObj.saveQuoteAccessUrl || commonService.commonMainObj.saveQuoteMessage">
  <div col="12">
    <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
      <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
      <div style="width:150px;  padding-left: 20px; background-color: #ffffff;">Quote</div>
      <div style="width:150px; padding-left: 15px;  background-color: #ffffff;">Save Quote</div>
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-8 text-center succ-div" style="margin-bottom:1rem !important;" *ngIf="commonService.commonMainObj.saveQuoteAccessUrl">
    <h2 style="color:#db9e0a;font-weight:600;">Your Quote is successfully saved!</h2>
    <p class="mt-3 fw-b">Your Quote Number is <span style="color:#db9e0a;font-weight:600 ;">{{commonService.commonMainObj.wqId}}</span>. To access the saved quote, please click <a href="{{commonService.commonMainObj.saveQuoteAccessUrl}}"  target="_blank" style="color:#db9e0a;font-weight:600 ;">SPX{{commonService.commonMainObj.spx}}</a></p>
  </div>
  <div class="col-8 text-center succ-div" style="margin-bottom:1rem !important;"  *ngIf="commonService.commonMainObj.saveQuoteMessage">
    <h2 style="color:red;font-weight:600;">Your Quote could not be saved!!</h2>
    <p class="mt-3 fw-b"><span style="color:#db9e0a;font-weight:600 ;">{{fisrtSavedMessageText}}</span> {{remainingSaveQuoteSentence}}</p>
  </div>
</div>
<div class="text-center">
  <button type="button" class="btn btn-custom mb-4 mt-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" *ngIf="commonService.commonMainObj.saveQuoteAccessUrl || commonService.commonMainObj.saveQuoteMessage" (click)="commonService.goBack()"> <b>Back to Home</b>
</button>
</div>
</div> -->
</div>
<ng-template #listOfSpecification let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">List of PCB Specifications that do not qualify for our best price</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    @if (!commonService.commonMainObj.greaterQtyResp && !commonService.commonMainObj.additionalTextHasl && !commonService.commonMainObj.additionalTextEnig) {
      <div class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
        <ul>
          @for (item of commonService.commonMainObj.customQuoteParam | keyvalue; track item) {
            <li style="list-style-type: auto;padding-bottom: 2px">{{item.value}}</li>
          }
        </ul>
        <!-- <div *ngFor="let item of commonService.commonMainObj.customQuoteParam | keyvalue">
        {{item.value}}
      </div> -->
        @if (commonService.commonMainObj.noPriceForTurntimeQtyCombination == true) {
          <div>
            Turntime {{commonService.commonMainObj.selectedFabTurntime}} for quantity {{commonService.commonMainObj.selectedFabQuantity}}
          </div>
        }
        @if (commonService.commonMainObj.noPriceForAllTurntimeQtyCombination == true) {
          <div>
            Turntime  @for (mat of commonService.commonMainObj.priceMatrixColData; track mat; let indx = $index) {
            <span >{{commonService.commonMainObj.priceMatrixColData[indx].field}}@if (indx < (commonService.commonMainObj.priceMatrixColData.length) - 1) {
              <span>, </span>
            }</span>
            }<span> for quantities </span> @for (element of commonService.commonMainObj.priceMatrixRowData; track element; let indx2 = $index) {
            <span>{{commonService.commonMainObj.priceMatrixRowData[indx2].turnTimeQuantity}}@if (indx2 < (commonService.commonMainObj.priceMatrixRowData.length) - 1) {
              <span>, </span>
              }</span>
            }
          </div>
        }
      </div>
    }
    @if (commonService.commonMainObj.greaterQtyResp && !commonService.commonMainObj.additionalTextHasl && !commonService.commonMainObj.additionalTextEnig) {
      <div class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
        @for (resp of greaterBomResponse; track resp; let indx3 = $index) {
          <div>{{resp}}</div>
        }
      </div>
    }
    @if(commonService.commonMainObj.additionalTextHasl){
      <div>{{commonService.commonMainObj.leadfreeHasl}} But value extracted is <b>{{this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance}}</b><i class="fa fa-info-circle info-icon file-info-icon" title ="Extracted File Name: {{this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance_extracted_from}}"></i>.</div>
    }
    @if(commonService.commonMainObj.additionalTextEnig){
      <div>{{commonService.commonMainObj.leadedEnig}} But value extracted is <b>{{this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance}}</b><i class="fa fa-info-circle info-icon file-info-icon" title ="Extracted File Name: {{this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance_extracted_from}}"></i>.</div>
    }
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-warning btn-min-wt" (click)="modal.close('cancel click')"><b>Ok</b></button>
  </div>
</ng-template>

<ng-template #LoginModal let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">
          @if (signInSec == true) {
            <div> Login </div>
          }
          @if (forgotPwdSec == true) {
            <div> Forgot Password </div>
          }
          @if (signUpSec == true) {
            <div> User registration </div>
          }
          @if (updatePwdSce == true) {
            <div> Update password </div>
          }
        </h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <section>
      <div class="row justify-content-center main-card m-0">
        <div class="col-11 mt-0 mb-2 content-sec">
          @if (signInSec == true) {
            <div>
              <h2 class="text-center fw6">Sign in to Sierra Circuits</h2>
            </div>
          }
          @if (signUpSec == true) {
            <div>
              <h2 class="text-center fw6">Sign up</h2>
              <p class="text-center"><b>It is quick and easy</b></p>
            </div>
          }
          @if (forgotPwdSec == true) {
            <div>
              <h2 class="text-center fw6">Forgot your password?</h2>
              <p class="text-center"><b>Reset password</b></p>
            </div>
          }
          @if (updatePwdSce == true) {
            <div>
              <h2 class="text-center fw6">Update password</h2>
            </div>
          }
          @if (verificationForm == true) {
            <div class="text-center">
              <img  src="/assets/img/verification.png" alt="shield" width="80" style="margin:0 10px;">
              <h2 class="text-center fw6">Enter verification code</h2>
              <div class="ion-text-center" style="margin-bottom:15px;">To ensure security, we have sent a  verification code to your registered email ID <br />Enter code below to login. The code is valid for 10 minutes.</div>
              <div class="ion-text-center">
                @if (resendCodeSuccess == true) {
                  <div class="success-message">Code is generated successfully and sent to your registered email ID</div>
                }
                @if (otpNotVerify == true) {
                  <div class="error-message">Verification Code sent for the last login is still active, please enter that code or click on 'Resend Verification Code'.</div>
                }
              </div>
              <div class="ion-text-center">
                @if (verificationFailed == true) {
                  <div class="verify-err-msg">Invalid code entered, please try again.</div>
                }
                @if (codeExpire == true) {
                  <div class="verify-err-msg">This Code is Expired. Please re-send the code and try again.</div>
                }
              </div>
            </div>
          }
          @if (signInSec == true) {
            <section class="mt-4" id="sign-in-sec">
              <form [formGroup]="signInForm">
                @if (unauthorizedUser == true) {
                  <div class="remaining-txt">
                    <strong>Email address or password incorrect.</strong>
                  </div>
                }
                @if (invalidAuthorizetion == true) {
                  <div class="remaining-txt text-center mb-3">
                    Invalid Email ID/ Password entered, please try again<br/>
                    <strong>Remaining login attempts: {{remainingAttempts}}</strong>
                  </div>
                }
                <div class="text-left">
                  <label for="sign_in_mail" class="">Email<span class="require-sym">&lowast;</span></label>
                  <input type="text" class="form-control" id="sign_in_mail" [(ngModel)]="signInMail" placeholder="name@example.com" name="login_email_address" formControlName="signInEmail" readonly  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                  @for (validation of signin_validation_messages.signInEmail; track validation) {
                    @if (signInForm.get('signInEmail')?.hasError(validation.type) && (signInForm.get('signInEmail')?.dirty || signInForm.get('signInEmail')?.touched)) {
                      <div class="error-message">
                        {{ validation.message }}
                      </div>
                    }
                  }
                </div>
                <div class="text-left">
                  <label for="sign_in_pwd" class="">Password<span class="require-sym">&lowast;</span></label>
                  <input type="password" class="form-control" id="sign_in_pwd" placeholder="Enter a password (5-50 charectors allowed)" formControlName="signInPWD"  required maxlength="100">
                </div>
                <div class="validation-errors">
                  @for (validation of signin_validation_messages.signInPWD; track validation) {
                    @if (signInForm.get('signInPWD')?.hasError(validation.type) && (signInForm.get('signInPWD')?.dirty || signInForm.get('signInPWD')?.touched)) {
                      <div class="error-message">
                        {{ validation.message }}
                      </div>
                    }
                  }
                </div>
                <div>
                  <div class="col-12 text-right" style="text-align: right;"><p class="forgot-txt" (click)="gotoForgotPwd()">Forgot password</p></div>
                  <div class="d-grid gap-2 mt-4">
                    <button type="button" class="btn btn-warning" [disabled]="!signInForm.valid" (click)="signIn()"><b>Sign in</b></button>
                    <!-- <button type="button" class="btn btn-warning"(click)="gotoSignup()">Not a member? Create an account</button> -->
                  </div>
                </div>
              </form>
            </section>
          }

          @if (signUpSec == true) {
            <section class="mt-4" id="sign-up-sec">
              <form [formGroup]="signUpForm">
                <div class="text-left">
                  <label for="sign_up_mail" class="">Email<span class="require-sym">&lowast;</span></label>
                  <input type="text" class="form-control" id="sign_up_mail" [(ngModel)]="signUpMail" placeholder="name@example.com" formControlName="signUpEmail" readonly  required>
                </div>
                <div class="validation-errors mb-2">
                  @for (validation of signup_validation_messages.signUpEmail; track validation) {
                    @if (signUpForm.get('signUpEmail')?.hasError(validation.type) && (signUpForm.get('signUpEmail')?.dirty || signUpForm.get('signUpEmail')?.touched)) {
                      <div class="error-message">
                        {{ validation.message }}
                      </div>
                    }
                  }
                </div>
                <div class="text-left mt-2">
                  <label for="sign_up_pwd" class="">Password<span class="require-sym">&lowast;</span></label>
                  <input type="password" class="form-control" id="sign_up_pwd" placeholder="Enter a password (5-50 charectors allowed)" formControlName="signUpPwd"  required>
                </div>
                <div class="validation-errors mb-2">
                  @for (validation of signup_validation_messages.signUpPwd; track validation) {
                    @if (signUpForm.get('signUpPwd')?.hasError(validation.type) && (signUpForm.get('signUpPwd')?.dirty || signUpForm.get('signUpPwd')?.touched)) {
                      <div class="error-message">
                        {{ validation.message }}
                      </div>
                    }
                  }
                </div>
                <div class="text-left mt-2">
                  <label for="first_name" class="">First name<span class="require-sym">&lowast;</span></label>
                  <input type="text" class="form-control" id="first_name" placeholder="Enter your first name" formControlName="signUpFirstName"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                  @for (validation of signup_validation_messages.signUpFirstName; track validation) {
                    @if (signUpForm.get('signUpFirstName')?.hasError(validation.type) && (signUpForm.get('signUpFirstName')?.dirty || signUpForm.get('signUpFirstName')?.touched)) {
                      <div class="error-message">
                        {{ validation.message }}
                      </div>
                    }
                  }
                </div>
                <div class="text-left mt-2">
                  <label for="last_name" class="">Last name<span class="require-sym">&lowast;</span></label>
                  <input type="text" class="form-control" id="last_name" placeholder="Enter your last name" formControlName="signUpLastName"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                  @for (validation of signup_validation_messages.signUpLastName; track validation) {
                    @if (signUpForm.get('signUpLastName')?.hasError(validation.type) && (signUpForm.get('signUpLastName')?.dirty || signUpForm.get('signUpLastName')?.touched)) {
                      <div class="error-message">
                        {{ validation.message }}
                      </div>
                    }
                  }
                </div>
                <!-- <div class="text-left mt-2">
                <label for="sign_up_mail" class="">Email<span class="require-sym">&lowast;</span></label>
                <input type="text" class="form-control" id="sign_up_mail" placeholder="name@example.com" formControlName="signUpEmail"  required maxlength="100">
              </div> -->
              <div class="text-left mt-2">
                <label for="company_name" class="">Company name<span class="require-sym">&lowast;</span></label>
                <input type="text" class="form-control" id="company_name" placeholder="Enter N/A if not applicable" formControlName="signUpCompanyName"  required maxlength="100">
              </div>
              <div class="validation-errors mb-2">
                @for (validation of signup_validation_messages.signUpCompanyName; track validation) {
                  @if (signUpForm.get('signUpCompanyName')?.hasError(validation.type) && (signUpForm.get('signUpCompanyName')?.dirty || signUpForm.get('signUpCompanyName')?.touched)) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
              <div class="text-left mt-2">
                <label for="phone_number" class="">Phone number<span class="require-sym">&lowast;</span></label>
                <input type="text" class="form-control" id="phone_number" placeholder="(212) 8798-8978" pattern="[0-9]*" formControlName="signUpPhoneNum"  required maxlength="100">
              </div>
              <div class="validation-errors mb-2">
                @for (validation of signup_validation_messages.signUpPhoneNum; track validation) {
                  @if (signUpForm.get('signUpPhoneNum')?.hasError(validation.type) && (signUpForm.get('signUpPhoneNum')?.dirty || signUpForm.get('signUpPhoneNum')?.touched)) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
              <div>
                <div class="col-12 text-center mt-2">By registering you agree the <a href="{{apiService.Terms_And_Conditions_URL}}" target="_blank">Terms & Conditions</a></div>
                <div class="d-grid gap-2 mt-4">
                  <button type="button" class="btn btn-warning" [disabled]="!signUpForm.valid" (click)="signUp()"><b>Create your account</b></button>
                  <!-- <button type="button" class="btn btn-warning"(click)="gotoSignIn()">Cancel</button> -->
                </div>
              </div>
            </form>
          </section>
        }

        @if (forgotPwdSec == true) {
          <section class="mt-4" id="forgot-pwd">
            <form [formGroup]="forgotPwdForm">
              <div class="text-left">
                <label for="forgot_pwd_mail" class="">Email<span class="require-sym">&lowast;</span></label>
                <input type="text" class="form-control" id="forgot_pwd_mail" [(ngModel)]="forgotMail" placeholder="name@example.com" formControlName="forgotPwdEmail" readonly  required maxlength="100">
              </div>
              <div class="validation-errors mb-2">
                @for (validation of forgot_validation_messages.forgotPwdEmail; track validation) {
                  @if (forgotPwdForm.get('forgotPwdEmail')?.hasError(validation.type) && (forgotPwdForm.get('forgotPwdEmail')?.dirty || forgotPwdForm.get('forgotPwdEmail')?.touched)) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
              <div>
                <div class="d-grid gap-2 mt-4">
                  <button type="button" class="btn btn-warning" [disabled]="!forgotPwdForm.valid" (click)="forgotPwd()"><b>Continue</b></button>
                  <button type="button" class="btn btn-warning"(click)="gotoSignIn()"><b>Cancel</b></button>
                </div>
              </div>
            </form>
          </section>
        }

        @if (updatePwdSce == true) {
          <section class="mt-4" id="update_pwd_sec">
            <form [formGroup]="updatePwdForm">
              <div class="text-left">
                <label for="update_pwd" class="">New password<span class="require-sym">&lowast;</span></label>
                <input type="password" class="form-control" id="update_pwd" placeholder="Enter new password" formControlName="newPwd"  required maxlength="100">
              </div>
              <div class="validation-errors mb-2">
                @for (validation of update_password_validation_messages.newPwd; track validation) {
                  @if (updatePwdForm.get('newPwd')?.hasError(validation.type) && (updatePwdForm.get('newPwd')?.dirty || updatePwdForm.get('newPwd')?.touched)) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
              <div class="text-left">
                <label for="update_confirm_pwd" class="">Confirm new password<span class="require-sym">&lowast;</span></label>
                <input type="password" class="form-control" id="update_confirm_pwd" placeholder="Confirm password" formControlName="confirmNewPwd"  required maxlength="100">
              </div>
              <div class="validation-errors mb-2">
                @for (validation of update_password_validation_messages.confirmNewPwd; track validation) {
                  @if (updatePwdForm.get('confirmNewPwd')?.hasError(validation.type) && (updatePwdForm.get('confirmNewPwd')?.dirty || updatePwdForm.get('confirmNewPwd')?.touched)) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
              <div>
                <div class="d-grid gap-2 mt-4">
                  <button type="button" class="btn btn-warning" [disabled]="!updatePwdForm.valid" (click)="updatePassword()"><b>Update passowrd</b></button>
                  <!-- <button type="button" class="btn btn-warning"(click)="gotoSignIn()">Cancel</button> -->
                </div>
              </div>
            </form>
          </section>
        }

        <!-- 2FA -->
        @if (verificationForm == true) {
          <section class="mt-4" id="2FA-sec">
            <form [formGroup]="verificationFormGroup" class="text-center">
              <div>
                <!-- <input type="text" class="verify-input" #otp1 id="otp1" required maxlength="1" tabindex="1" formControlName="vCode1" (keyup)="otpController($event,'',otp1,otp2)">
                <input type="text" class="verify-input" #otp2 id="otp2" required maxlength="1" tabindex="2" formControlName="vCode2" (keyup)="otpController($event,otp1,otp2,otp3)">
                <input type="text" class="verify-input" #otp3 id="otp3" required maxlength="1" tabindex="3" formControlName="vCode3" (keyup)="otpController($event,otp2,otp3,otp4)">
                <span class="v-hyphen">-</span>
                <input type="text" class="verify-input" #otp4 id="otp4" required maxlength="1" tabindex="4" formControlName="vCode4" (keyup)="otpController($event,otp3,otp4,otp5)">
                <input type="text" class="verify-input" #otp5 id="otp5" required maxlength="1" tabindex="5" formControlName="vCode5" (keyup)="otpController($event,otp4,otp5,otp6)">
                <input type="text" class="verify-input" #otp6 id="otp6" required maxlength="1" tabindex="6" formControlName="vCode6" (keyup)="otpController($event,otp5,otp6,'')"> -->
                <input class="verify-input" #otp1 id="otp1" maxLength="1" formControlName="vCode1" tabindex="1" (paste)="clipboardEvent($event)" (keyup)="otpController($event,'',otp1,otp2)">
                <input class="verify-input" #otp2 id="otp2" maxLength="1" formControlName="vCode2" tabindex="2" (keyup)="otpController($event,otp1,otp2,otp3)">
                <input class="verify-input" #otp3 id="otp3" maxLength="1" formControlName="vCode3" tabindex="3" (keyup)="otpController($event,otp2,otp3,otp4)">
                <span class="v-hyphen">-</span>
                <input class="verify-input" #otp4 id="otp4"  maxLength="1" formControlName="vCode4" tabindex="4" (keyup)="otpController($event,otp3,otp4,otp5)">
                <input class="verify-input" #otp5 id="otp5" maxLength="1" formControlName="vCode5" tabindex="5" (keyup)="otpController($event,otp4,otp5,otp6)">
                <input class="verify-input" #otp6 id="otp6" maxLength="1" formControlName="vCode6" tabindex="6" (keyup)="otpController($event,otp5,otp6,'')">
              </div>
              <div class="row justify-content-center">
                <div class="col-6 d-grid gap-2 mt-4">
                  <!-- <button type="button" id="panel-verify-code-button" class="btn btn-warning" [disabled]="!verificationFormGroup.valid" expand="block" (click)="verifyOtp()">Verify</button> -->
                  <button type="button" class="btn btn-warning" expand="block" (click)="verifyOtp()"><b>Verify</b></button>
                </div>
                <div class="col-12 d-grid gap-2 mt-3">
                  <p>Haven't recieved it? <a class="resend-link" style="cursor: pointer;" (click)="resendNewCode()" >Resend verification code</a></p>
                </div>
              </div>
            </form>
          </section>
        }

        <!--account locked-->
        @if (accountLocked == true) {
          <section class="mt-4" id="2FA-sec">
            <div class="row justify-content-center">
              <div class="col-12 d-grid gap-2 mt-4 text-center TFA_bg-red-section">
                <p>Your account is temporarily locked for a duration of <b>2 hours</b> as a result of repeated unsuccessful login attempts.</p>
                <p>To unlock your account before the 2-hour period, please get in touch with <b>Sierra Customer Support</b>.</p>
                <div style="font-weight: bold;line-height: 1;">Gyanendra Behera</div>
                <div style="font-weight: bold;line-height: 1;">Email: <a  style="color: #cf102d;text-decoration: none;" href ="mailto:ssdc_gyanendrab@protoexpress.com"> ssdc_gyanendrab&#64;protoexpress.com</a></div>
                <div style="font-weight: bold;line-height: 1;">Call: <a style="color: #cf102d;text-decoration: none;" href="tel:+1 408 539 0778"> +1 (408) 539 0778</a></div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-4 d-grid gap-2 mt-4">
                <button type="button" class="btn btn-warning" (click)="closeAccountLockScreen()"><b>Close</b></button>
              </div>
            </div>
          </section>
        }
      </div>
    </div>
  </section>
</div>
<!-- <div class="modal-footer text-center" style="display: block;">
<button type="button" class="btn btn-warning btn-min-wt" (click)="modal.close('cancel click')">Ok</button>
</div> -->
</ng-template>
<!-- FOR ASSEMBLY ERRORS -->
<ng-template #assemblyErrorModal let-modal>
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">Assembly File Errors</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <!-- OFP-3156 changed the below text -->
    <div class="text-center text-danger">Please resolve errors to get assembly quote.</div>
    <!-- <button type="button" (click)="reValidate();"></button> -->
    <div>
      <div class="p-2 bg-warnings fw-b">Errors:</div>
      <div class="brd_warning">
        <ul class="list-type-number">
          <!-- <li *ngFor="let assmblyErr of commonService.commonMainObj.uploadedFilesData?.fileAsmblyErrors">{{assmblyErr.error}} <span class="fa fa-info-circle" title="{{assmblyErr.description}}"></span><button type="button" class="btn btn-warning btn-min-wt"><i class="fa fa-cloud-upload"></i> Upload</button></li> -->
          @for (assmblyErr of commonService.commonMainObj.uploadedFilesData?.fileAsmblyErrors; track assmblyErr; let idx = $index) {
            <li style="display: flex;align-items: center;">
              <div style="width: 60%;">
                {{idx+1}}. {{assmblyErr.error}} <span class="fa fa-info-circle m-2" title="{{assmblyErr.description}}"></span>
              </div>
              <label for="{{assmblyErr.errorCode}}" class="m-2 missing-file-lable">
                <input type="file" class="missing-file-input" id="{{assmblyErr.errorCode}}" (change)="missingFilesHandel($event, ''+assmblyErr.errorCode)">
                <i class="fa fa-cloud-upload"></i> Upload
              </label>
              <div>
                <span id="{{assmblyErr.errorCode}}_name" class="file-color m-2"></span>
                <span style="display: none;" class="delete-file" id="{{assmblyErr.errorCode}}_delete" (click)="deleteFile(''+assmblyErr.errorCode)"><i class="fa fa-solid fa-trash"></i></span>
              </div>
              <span id="{{assmblyErr.errorCode}}_error" class="error-message"></span>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-danger btn-min-wt" (click)="modal.close('cancel click')"><b>Cancel</b></button>
    <button type="button" class="btn btn-warning btn-min-wt" id="assembly_error_proceed" [disabled]="disableAssemblyErrorProceed == true" (click)="reValidate()"><b>Proceed</b></button>
  </div>
</ng-template>
<ng-template #autoMapping let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">BOM Column Mapping</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  @if (showNumberOfSheets) {
    <div class="modal-body pt-0">
      <div class="row m-0 mt-2 mb-3">
        <div class="col">
          <div class="text-center mb-3"><b><u>Map the column headings for your BOM</u></b></div>
          <div class="text-center fs14 text-danger"> <b>Note: </b> Please select the column name for the mandatory columns that are not auto-mapped. If any of the mandatory columns are not present in the BOM, click on "Cancel" button and upload a new BOM that has all the mandatory columns.</div>
        </div>
      </div>
      <!-- Changes done based on OFP-652 -->
      <div [hidden]="mainRowArrayObj['labelsArray'].length == 0">
        @for (cma of mainRowArrayObj['labelsArray']; track cma; let idx = $index) {
          <div class="row justify-content-md-center" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
            @if ((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')) {
              <div class="row justify-content-md-center" >
                <div class="col-sm-3">
                  <div>
                    @if (cma.labelType != 'new') {
                      <label>{{cma.labelName}}@if ((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')) {
                        <span class="text-danger">*</span>
                      }</label>
                    }
                  </div>
                </div>
                <div class="col-sm-4">
                  <!-- (change)="changeColumnData(idx,cma.selectedName1,'1')" -->
                  <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" [ngClass]="cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number' ? 'requiredField' : 'notRequireField'" placeholder="Select" [(ngModel)]="cma.selectedName1" (change)="checkIfAllOptionsPresent()">
                    <option value="">Select</option>
                    @for (crow of mainRowArrayObj['bomOneMapArrayData']; track crow) {
                      <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj">
                        {{crow.labelValue}}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div [hidden]="mainRowArrayObj['labelsArray'].length == 0">
        @for (cma of mainRowArrayObj['labelsArray']; track cma; let idx = $index) {
          <div class="row justify-content-md-center" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
            @if (!(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')) {
              <div class="row justify-content-md-center" >
                <div class="col-sm-3">
                  <div>
                    @if (cma.labelType != 'new') {
                      <label>{{cma.labelName}}@if ((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')) {
                        <span class="text-danger">*</span>
                      }</label>
                    }
                  </div>
                </div>
                <div class="col-sm-4">
                  <!-- (change)="changeColumnData(idx,cma.selectedName1,'1')" -->
                  <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" placeholder="Select" [(ngModel)]="cma.selectedName1">
                    <option value="">Select</option>
                    @for (crow of mainRowArrayObj['bomOneMapArrayData']; track crow) {
                      <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj">
                        {{crow.labelValue}}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (!showNumberOfSheets) {
    <div class="modal-body">
      <div class="row m-0 mt-2 mb-3">
        <div class="col">
          <div class="text-center clr_green mb-5"><b>Your excel has multiple worksheets. Please specify worksheet that has BOM info.</b></div>
          <div class="row justify-content-md-center">
            <div class="col-sm-3">
              <label>Select Sheet: </label>
            </div>
            <div class="col-sm-4">
              <select class="form-control form-select mb-3" placeholder="Select" [(ngModel)]="selectedSheetNum">
                <option value="">Select</option>
                @for (sheet of sheetsArray; track sheet) {
                  <option value="{{sheet.index}}">
                    {{sheet.name}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!showNumberOfSheets) {
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5" (click)="proceedSheet()"><b>Proceed</b></button>
    </div>
  }
  @if (showNumberOfSheets) {
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 mr-25 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
      <button type="button" class="btn btn-custom btn-warning px-xxl-5" id="automap-modal-proceed-btn" (click)="proceedAutoMapData()" ><b>Proceed</b></button>
      <!-- (click)="modal.close('Save click')" [disabled]="disableAutomapProceed == true" OFP-613 -->
    </div>
  }
</ng-template>
<ng-template #existingQuote let-modal>
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title"></h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <!-- (click)="changeQuote()" -->
    <div class="p-3 m-3">You have already created a quote <b><a  class="text_deco_underline">{{newChangeQuoteId}}</a></b> for the given turntime and quantity. Please click on <b>Open Existing Quote</b> button; else, click on <b>‘Generate New Quote’</b> button to get a new quote </div>
    <div class="text-center">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-1" (click)="generateQuote()"><b>Generate New Quote</b></button>
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-1" (click)="changeQuote()"><b>Open Existing Quote</b></button>
    </div>
  </div>
</ng-template>

<ng-template #unResolveLineItems let-modal>
  <div class="modal-header">
    <div class="row col">
      <div class="col-11">
        <h4 class="modal-title" id="modal-basic-title">Unresolved Line Items</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="col-sm-12" style="position: relative;">
      <div class="table-responsive table_height_auto" id="unResolveTable">
        <table width="100%" border="0" cellspacing="0" cellpadding="0" id="quote-items-to-purchase" class="table table-bordered">
          <thead class="bg-warning text-center">
            <tr>
              <th class="bg-warning" style="width: 2%;font-size: 14px;" align="center" valign="middle">Item Number</th>
              <th class="bg-warning" style="width: 10%;font-size: 14px;" align="center" valign="middle">Manufacturer Part Number</th>
              <th class="bg-warning" style="width: 15%;font-size: 14px;" align="center" valign="middle">Reference Designators</th>
              <th class="bg-warning" style="width: 15%;font-size: 14px;" align="center" valign="middle">Issue</th>
            </tr>
          </thead>
          <tbody id="display-tbody-issues">
            @for (issuesObj of commonService.commonMainObj.finalBomDataToPurchase?.issueFound?.items; track issuesObj; let in = $index) {
              <tr>
                <td align="center" valign="top">{{issuesObj.itemNo}}</td>
                <td align="center" valign="top">{{issuesObj.mpn}}</td>
                <td align="center" valign="top">{{issuesObj.referenceDesignator}}</td>
                <td align="center" valign="top">{{issuesObj.issueName}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    @if (commonService.commonMainObj.finalBomDataToPurchase?.issueFound != null && !commonService.commonMainObj.greaterQtyResp && !commonService.commonMainObj.reQuoteCheck) {
      <button  type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="backToComponentProcurement()"><b>Back</b></button>
    }
  </div>
</ng-template>
<app-footer></app-footer>